<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <template v-if="customerItem.includes(item.item.id.toString())">
      <i class="fa fa-user-circle-o"
         v-tooltip
         data-toggle="tooltip"
         data-placement="top"
         :title="$translate('Bigtex5::Template.customerItemBought')"></i>
    </template>
    <span class="kept-items-badge" v-if="keptQuantity > 0">
      {{ keptQuantity }}x bestellt
    </span>
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-image">
        <template v-if="attributeColors.length > 0 && showAttr === 'true'">
          <ul class="cat-attr-color-list-text" v-if="attributeColors.length > 4" role="list">
            <li>{{ $translate("Bigtex5::Template.manyColorsAvailable") }}</li>
          </ul>
          <div class="cat-attr-color-list d-none" v-else>
            <template v-for="attr in attributeColors">
              <a :aria-label="'goTo-color-' + attr.color" :href="attr.itemUrl" v-tooltip="true" data-placement="right" data-toggle="tooltip" data-html="true" :data-title="`<img src='${attr.imageUrl}' class='max-attr-image'>`">
                <span :style="{ backgroundColor: attr.color }"></span>
              </a>
            </template>
          </div>
        </template>
        <template v-if="attributeText.length > 0 && showAttr === 'true'">
          <ul class="cat-attr-text-list" role="list">
            <li v-if="attributeText.length > 9">
              {{ $translate("Bigtex5::Template.manyVariationsAvailable") }}
            </li>
            <template v-else>
              <li v-for="attr in attributeText" :key="attr" v-if="attr != 'XXL' && attr != '2XL'">
                {{ attr }}
              </li>
            </template>
          </ul>
        </template>

        <div class="prop-1-1">
          <slot name="item-image">
            <category-image-carousel
                :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                :alt="item | itemName"
                :title="item | itemName"
                :item-url="item | itemURL(urlWithVariationId)"
                :enable-carousel="$ceres.config.item.enableImageCarousel"
                :disable-carousel-on-mobile="disableCarouselOnMobile"
                ref="categoryImageCarousel">
            </category-image-carousel>
          </slot>
        </div>
      </div>

      <!-- "Xx bestellt" hat Vorrang: dann oben links kein weiteres Badge -->
      <template v-if="keptQuantity > 0"></template>

      <template v-else-if="blackday.tag.length > 0 && blackday.active">
        <div class="special-tags">
          <div class="badge badge-new badge-primary blackday">
            <i class="fa fa-fire" aria-hidden="true"></i>
            {{ blackday.tag[0].names.name }}
          </div>
        </div>
      </template>

      <template v-else>
        <slot name="store-special">
          <item-store-special
              v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
              :store-special="storeSpecial"
              :recommended-retail-price="item.prices.rrp"
              :variation-retail-price="item.prices.default"
              :special-offer-price="item.prices.specialOffer"
              :decimal-count="decimalCount"
              :bundle-type="item.variation.bundleType"
              :item-type="item.item.itemType">
          </item-store-special>
        </slot>
      </template>

      <csaddtolist :variation-id="0" :current-item-id="item.item.id"></csaddtolist>

      <slot name="item-details">
        <section class="thumb-content">
          <b>{{ item.item.manufacturer.externalName }} </b>
          <a
              :aria-label="'kategorieartikel-' + item.texts.name1"
              :href="item | itemURL(urlWithVariationId)"
              class="thumb-title"
              :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId === 0 }">
            {{ item.texts.shortDescription }}
            <span v-for="attribute in item.groupedAttributes" :key="attribute">
              {{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}
            </span>
          </a>
          <div class="thumb-meta mb-2">
            <slot name="before-prices"></slot>
            <div :class="{'cross-cont': isCrossedPrice}" class="priceflex text-center justify-content-center row">
              <div v-if="isCrossedPrice" class="col-xl-6 col-12 px-0">
                <span class="catcross crossprice" v-if="item.prices.specialOffer">
                  {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </span>
                <span class="catcross crossprice" v-else>
                  {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </span>
              </div>
              <div class="price col-xl-6 col-12 px-0 ">
                <template v-if="item.item.itemType === 'set'">
                  {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }} *
                </template>
                <template v-else-if="item.item && hasAbPrice">
                   {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }} *
                </template>
                <template v-else>
                  {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }} *
                </template>
              </div>
            </div>
          </div>
          <slot name="after-prices"></slot>
        </section>
      </slot>
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "../components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial
  },

  props: {
    decimalCount: {
      type: Number,
      default: 0
    },
    imageUrlAccessor: {
      type: String,
      default: "urlMiddle"
    },
    itemData: {
      type: Object
    },
    disableCarouselOnMobile: {
      type: Boolean
    },
    paddingClasses: {
      type: String,
      default: null
    },
    paddingInlineStyles: {
      type: String,
      default: null
    },
    forceUrlWithVariationId: {
      type: Boolean,
      default: false
    }
  },

  jsonDataFields: ["itemDataRef"],
  data() {
    return {
    };
  },
  computed: {

    hasAbPrice() {
      const props = this.item.variationProperties || [];
      const group = props.find(p => p.id === 2);

      if (!group) {
        return false;
      }

      const prop310 = group.properties.find(p => p.id === 310);

      if (!prop310 || !prop310.values) {
        return false;
      }

      const value = Number(prop310.values.value);

      return !isNaN(value) && value > 1;
    },
    showAttr() {
      return App.showAttr;
    },

    attributeColors() {
      const props = this.item.variationProperties || [];
      const colorProps = props.find(p => p.id === 2)?.properties.find(p => p.id === 301);
      if (colorProps && colorProps.values && typeof colorProps.values.value === 'string' && colorProps.values.value.trim() !== '' && colorProps.values.value !== null ) {
        return JSON.parse(colorProps.values.value)
      }
      return [];
    },
    attributeText() {
      const props = this.item.variationProperties || [];
      const textProps = props.find(p => p.id === 2)?.properties.find(p => p.id === 297);
      if (textProps && textProps.values && typeof textProps.values.value === 'string' && textProps.values.value.trim() !== ''  && textProps.values.value !== null) {
        return textProps.values.value.split(',');
      }
      return [];
    },
    blackday() {
      const tags = this.item.tags || [];
      const blackTags = tags.filter(tag => tag.id === 43);
      return { tag: blackTags, active: App.black === '1' };
    },
    customerItem() {
      return App.customerItems || [];
    },
    keptQuantity() {
      const keptItems = App.keptItems || {};

      if (keptItems[this.item.variation.id]) {
        return keptItems[this.item.variation.id];
      }

      // ohne Kept-Filter zeigt die Liste die Hauptvariante des Artikels,
      // die gekaufte Variante matcht dann nicht -> zusätzlich über die Item-ID
      const keptDetails = App.keptItemsDetails || [];
      const keptForItem = keptDetails.find(kept => kept.itemId === this.item.item.id);

      return keptForItem ? keptForItem.quantity : 0;
    },
    item() {
      return this.itemData || this.itemDataRef;
    },
    storeSpecial() {
      return this.item.item.storeSpecial;
    },
    texts() {
      return this.item.texts;
    },
    itemPrice() {
      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },
    itemSetPrice() {
      return this.$options.filters.currency(this.item.prices.default.price.value, this.item.prices.default.currency);
    },
    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect === 0 || this.forceUrlWithVariationId;
    },
    isCrossedPrice() {
      return this.item.prices.rrp?.price.value > 0 && this.item.prices.rrp.price.value > this.item.prices.default.unitPrice.value;
    },
    ...mapState({
      showNetPrices: state => state.basket.showNetPrices
    })
  }
};
</script>
